export interface PadDevice {
  index: string;
  type: number;
  comPort: string;
  connectionType: string;
  firmwareVersion: string;
  ipAddress: string;
  serialNumber: string;
  capabilities: string;
}

export interface PadSearchResponse {
  command: string;
  returnCode: number;
  foundPads: Array<PadDevice>;
}

export type SignoPadErrorMessage = string;
export interface SignoPadSignature {
  image: Base64DataURI;
  cert: string;
}
export type Base64DataURI = string;
export enum SignoPadApiState {
  API_CONNECTED,
  API_DISCONNECTED,
}

export enum SignoPadDeviceState {
  DEVICE_CONNECTED,
  DEVICE_DISCONNECTED,
}

export enum CreateConnectionError {
  // tslint:disable-next-line: quotemark max-line-length
  WS_ALREADY_CREATED = "WebSocket object is already created. Please call 'STPadServerLibCommons.destroyConnection()' first!",
  DEVICE_CONNECTION_ALREADY_CREATED = 'Es wurde bereits eine Verbindung geöffnet.',
}
